import { create } from "zustand";
import { API_URL } from "../Config/config";
import axiosInstance from "../services/axiosInstance";
import areaServices from "../services/area.service";

const useDistributorStore = create((set, get) => ({
    fetchDistributors: async (body) => {
        try {
            const { limit, offset } = body;

            let URL = API_URL + "users/dashboard-distributor";

            const result = await axiosInstance.get(URL,{params : body});
            const response = result.data;

            if (response.code == 200) {
                return { status: true, data: response.data };
            } else {
                return { status: false, data: response.data };
            }
        } catch (err) {
            return { status: false, data: err.response };
        }
    },
    fetchStatesList: async () => {
        try {
          const response = await areaServices.getStateList();
          if (!response?.status) {
            return { status: false, data: response.data };
          } else {
            return {status: true, data: response.data}
          }
        } catch (err) {
            return { status: false, data: err.response };
        } 
    },
    fetchDistrictsList: async (params) => {
        try {
          const response = await areaServices.getDistrictList(params);
          if (!response?.status) {
            return { status: false, data: response.data };
          } else {
            return {status: true, data: response.data}
          }
        } catch (err) {
            return { status: false, data: err.response };
        } 
    },
    createDistributor: async (filter) => {
      console.log(filter, 'filters')
      const updatedFilter = {...filter, role: Number(filter.role)}
      try {
          let URL = API_URL + 'users/create-distributor'

          const result = await axiosInstance.post(URL, updatedFilter)
          const response = result.data 

          return {status: true, data: response.data}
      } catch(e) {
          return {status: false, data: e.response}
      }
  },
  editDistributor: async (filter) => {
      console.log(filter, 'filters')
      const updatedFilter = {...filter, role: Number(filter.role)}
      try {
          let URL = API_URL + 'users/update-distributor'

          const result = await axiosInstance.post(URL, updatedFilter)
          const response = result.data 

          return {status: true, data: response.data}
      } catch(e) {
          return {status: false, data: e.response}
      }
  },
}));

export { useDistributorStore };